import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import "../../components/styles/alertify.min.css";

export default async function updateRecuperacion(status, id) {
  const js = JSON.stringify(status);
  const endpoint = localStorage.getItem("endpoint");

  const url = endpoint + "adm_ubicaciones/recuperacion/" + id;

  try {
    const config = { method: "PUT", body: js, headers: {} };
    const response = await fetch(url, config);
    const json = await response.json();
    if (json.message === "Se editó la recuperación correctamente") {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
      alertify.success("Registro Modificado");
    } else {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
      alertify.error("No fue posible modificar el elemento");
    }
  } catch (error) {
    console.log("Error" + error);
  }
}
